/* eslint-disable import/prefer-default-export */

export { default as ItemCards } from './ItemCardsWrapperConnector';
